import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer_container container">
                <h1 className="footer__title">Leela Krishna Sai</h1>

                <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="#skills" className="footer__link">Skills</a>
                    </li>

                    <li>
                        <a href="#portfolio" className="footer__link">Projects</a>
                    </li>
                </ul>

                <div className="footer__social">

                    <a href="https://www.linkedin.com/in/leelakrishnasai" className="footer__social-link" target="_blank" rel="noopener noreferrer">
                        <i class="bx bxl-linkedin"></i>
                    </a>

                    <a href="https://github.com/Leelakrishnasai24" className="footer__social-link" target="_blank" rel="noopener noreferrer">
                        <i class="bx bxl-github"></i>
                    </a>

                    <a href="https://www.instagram.com/lks_edits_" className="footer__social-link" target="_blank" rel="noopener noreferrer">
                        <i class="bx bxl-instagram"></i>
                    </a>
                </div>
{/* 
                <span className="footer__copy">
                    &#169; LeelaKrishnaSai. All rigths reserved
                </span> */}
            </div>
        </footer>
    )
}

export default Footer